// ENTITY com.ic2.entity.UserRelation generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class UserRelation {

  static readonly __ic2_fqn: string = 'com.ic2.entity.UserRelation';

  idUser: number | null = 0;
  idUserLie: number | null = 0;
  typeRelation: number | null = 0;

  constructor(init?:Partial<UserRelation>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.entity.UserRelation'] = UserRelation;

fields['com.ic2.entity.UserRelation']  = {
    idUser: 'java.lang.Integer',
    idUserLie: 'java.lang.Integer',
    typeRelation: 'java.lang.Integer'
};
